export default __webpack_public_path__ + "static/media/No85Closed.5423911b.jpg";